import React from "react";

const CustomDateInput = React.forwardRef(({ value, lable, onClick }, ref) => (
  <div className="custom-date-input" onClick={onClick} ref={ref}>
    <img src="./images/icons/date.svg" alt="icon" className="datepicker-icon" />
    <p>{lable}</p>
    <input type="text" placeholder="Select date" value={value} />
  </div>
));

export default CustomDateInput;
